module.exports = __webpack_public_path__ + "static/media/file-earmark-medical.35d95567.svg";